var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app"},[(_vm.loading)?_c('div',{staticClass:"loading-page"},[_c('a-spin',{staticStyle:{"width":"100%","height":"100vh","padding-top":"120px"},attrs:{"size":"large","tip":"加载中...","spinning":_vm.loading}})],1):[_c('div',{staticClass:"content"},[_vm._t("default")],2)]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }